// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__gs0JS","label":"SetPasswdForm_label__2dNff"};